import React, {FC, useEffect, useState} from 'react'
import { Centralizer, Button } from "../../components"
import { useTranslate } from '../../hooks'

type Props = {
  show: boolean,
  //save: () => void, -- Should be done via FORM and submit
  undo?: () => void
}

const ChangeDialog: FC<Props> = ({show, undo}) => {

  const [ showDialog, setShowDialog] = useState(show);
  const { t } = useTranslate()

  useEffect(() => {
    setShowDialog(show)
  }, [show])

  return (<>{showDialog &&
  <div style={{
    position: "fixed",
    bottom: "1.5rem",
    width: "100vw",
    left: 0,
    pointerEvents: 'none',
    zIndex: '10'
  }}>
    <Centralizer>
      <Centralizer>
        <div className="bg-schipt-darkest/40 dark:bg-schipt-white/30 pointer-events-auto rounded-md flex justify-between w-full shadow-lg">
          <Button className="schipt-btn primary" variant='save' _type="submit" style={{
            margin: "1rem 3rem", height:"2.5rem", lineHeight:"1.9rem",           
          }}
          //onClick={async () => await save()}
          >{t("saveChanges")}</Button>

          {undo && 
            <Button className="schipt-btn primary" variant='delete' _type="button" style={{
              margin: "1rem 3rem",height:"2.5rem", lineHeight:"1.9rem",            
            }}
            onClick={async () => await undo()}
            >{t("undoChanges")}</Button>
          }

          
        </div>
      </Centralizer>
    </Centralizer>
  </div>
  }</>)
}

export default ChangeDialog